import { Product } from "@common/product";

export interface AdminProductsState {
  products: Product[];
  totalElements: number;
  totalPages: number;
  currentPage: number;
  isLoading: boolean;
  error: any;
}

export const initialState: AdminProductsState = {
  products: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  isLoading: false,
  error: null
};
